import { EDGELESS_CANVAS_CARD_BACKGROUND } from '@blocksuite/affine-shared/consts';
import { baseTheme } from '@streamlain/theme';
import { css, unsafeCSS } from 'lit';

import { AIChatEmptyStateStyles } from '../../components/ai-chat-empty-state';

export const AIChatBlockStyles = css`
  ${AIChatEmptyStateStyles}

  .affine-ai-chat-block-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 16px;
    background: ${unsafeCSS(EDGELESS_CANVAS_CARD_BACKGROUND)};
    color: var(--streamlain-text-primary-color);
    line-height: 22px;
    font-size: var(--streamlain-font-sm);
    font-family: ${unsafeCSS(baseTheme.fontSansFamily)};
    border-radius: 8px;
    user-select: none;
    pointer-events: none;

    .ai-chat-messages-container {
      display: block;
      flex: 1 0 0;
      width: 100%;
      box-sizing: border-box;
      overflow: auto;
      pointer-events: auto;
      user-select: text;
    }

    .ai-chat-empty-turn {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
    }
  }
`;
